// @ts-nocheck
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
var Query_possibleTypes = ['Query'];
export var isQuery = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isQuery"');
    return Query_possibleTypes.includes(obj.__typename);
};
var UserInfo_possibleTypes = ['UserInfo'];
export var isUserInfo = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isUserInfo"');
    return UserInfo_possibleTypes.includes(obj.__typename);
};
var Session_possibleTypes = ['Session'];
export var isSession = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isSession"');
    return Session_possibleTypes.includes(obj.__typename);
};
var LoginHistory_possibleTypes = ['LoginHistory'];
export var isLoginHistory = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isLoginHistory"');
    return LoginHistory_possibleTypes.includes(obj.__typename);
};
var ListUser_possibleTypes = ['ListUser'];
export var isListUser = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListUser"');
    return ListUser_possibleTypes.includes(obj.__typename);
};
var ItemUser_possibleTypes = ['ItemUser'];
export var isItemUser = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemUser"');
    return ItemUser_possibleTypes.includes(obj.__typename);
};
var CountersUser_possibleTypes = ['CountersUser'];
export var isCountersUser = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersUser"');
    return CountersUser_possibleTypes.includes(obj.__typename);
};
var ListStorage_possibleTypes = ['ListStorage'];
export var isListStorage = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListStorage"');
    return ListStorage_possibleTypes.includes(obj.__typename);
};
var ItemStorage_possibleTypes = ['ItemStorage'];
export var isItemStorage = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemStorage"');
    return ItemStorage_possibleTypes.includes(obj.__typename);
};
var CountersStorage_possibleTypes = ['CountersStorage'];
export var isCountersStorage = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersStorage"');
    return CountersStorage_possibleTypes.includes(obj.__typename);
};
var InitSyncDictionaryItems_possibleTypes = ['InitSyncDictionaryItems'];
export var isInitSyncDictionaryItems = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isInitSyncDictionaryItems"');
    return InitSyncDictionaryItems_possibleTypes.includes(obj.__typename);
};
var InitSyncDictionaryData_possibleTypes = ['InitSyncDictionaryData'];
export var isInitSyncDictionaryData = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isInitSyncDictionaryData"');
    return InitSyncDictionaryData_possibleTypes.includes(obj.__typename);
};
var InitSyncDictionaryDocument_possibleTypes = ['InitSyncDictionaryDocument'];
export var isInitSyncDictionaryDocument = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isInitSyncDictionaryDocument"');
    return InitSyncDictionaryDocument_possibleTypes.includes(obj.__typename);
};
var InitSyncDictionarySyncDocument_possibleTypes = ['InitSyncDictionarySyncDocument'];
export var isInitSyncDictionarySyncDocument = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isInitSyncDictionarySyncDocument"');
    return InitSyncDictionarySyncDocument_possibleTypes.includes(obj.__typename);
};
var ListProduct_possibleTypes = ['ListProduct'];
export var isListProduct = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListProduct"');
    return ListProduct_possibleTypes.includes(obj.__typename);
};
var ListOutputProduct_possibleTypes = ['ListOutputProduct'];
export var isListOutputProduct = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputProduct"');
    return ListOutputProduct_possibleTypes.includes(obj.__typename);
};
var ProductCategoryOutput_possibleTypes = ['ProductCategoryOutput'];
export var isProductCategoryOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isProductCategoryOutput"');
    return ProductCategoryOutput_possibleTypes.includes(obj.__typename);
};
var ProductBrandOutput_possibleTypes = ['ProductBrandOutput'];
export var isProductBrandOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isProductBrandOutput"');
    return ProductBrandOutput_possibleTypes.includes(obj.__typename);
};
var CountersProduct_possibleTypes = ['CountersProduct'];
export var isCountersProduct = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersProduct"');
    return CountersProduct_possibleTypes.includes(obj.__typename);
};
var ItemOutputProduct_possibleTypes = ['ItemOutputProduct'];
export var isItemOutputProduct = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputProduct"');
    return ItemOutputProduct_possibleTypes.includes(obj.__typename);
};
var ProductOutput_possibleTypes = ['ProductOutput'];
export var isProductOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isProductOutput"');
    return ProductOutput_possibleTypes.includes(obj.__typename);
};
var SimpleProduct_possibleTypes = ['SimpleProduct'];
export var isSimpleProduct = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isSimpleProduct"');
    return SimpleProduct_possibleTypes.includes(obj.__typename);
};
var ListProductBrand_possibleTypes = ['ListProductBrand'];
export var isListProductBrand = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListProductBrand"');
    return ListProductBrand_possibleTypes.includes(obj.__typename);
};
var ItemProductBrand_possibleTypes = ['ItemProductBrand'];
export var isItemProductBrand = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemProductBrand"');
    return ItemProductBrand_possibleTypes.includes(obj.__typename);
};
var CountersProductBrand_possibleTypes = ['CountersProductBrand'];
export var isCountersProductBrand = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersProductBrand"');
    return CountersProductBrand_possibleTypes.includes(obj.__typename);
};
var ListCheckPriceMonitor_possibleTypes = ['ListCheckPriceMonitor'];
export var isListCheckPriceMonitor = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListCheckPriceMonitor"');
    return ListCheckPriceMonitor_possibleTypes.includes(obj.__typename);
};
var ListOutputCheckPriceMonitor_possibleTypes = ['ListOutputCheckPriceMonitor'];
export var isListOutputCheckPriceMonitor = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputCheckPriceMonitor"');
    return ListOutputCheckPriceMonitor_possibleTypes.includes(obj.__typename);
};
var CountersCheckPriceMonitor_possibleTypes = ['CountersCheckPriceMonitor'];
export var isCountersCheckPriceMonitor = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersCheckPriceMonitor"');
    return CountersCheckPriceMonitor_possibleTypes.includes(obj.__typename);
};
var ItemOutputCheckPriceMonitor_possibleTypes = ['ItemOutputCheckPriceMonitor'];
export var isItemOutputCheckPriceMonitor = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputCheckPriceMonitor"');
    return ItemOutputCheckPriceMonitor_possibleTypes.includes(obj.__typename);
};
var OutputProduct_possibleTypes = ['OutputProduct'];
export var isOutputProduct = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isOutputProduct"');
    return OutputProduct_possibleTypes.includes(obj.__typename);
};
var ListCheckPriceLink_possibleTypes = ['ListCheckPriceLink'];
export var isListCheckPriceLink = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListCheckPriceLink"');
    return ListCheckPriceLink_possibleTypes.includes(obj.__typename);
};
var ListOutputCheckPriceLink_possibleTypes = ['ListOutputCheckPriceLink'];
export var isListOutputCheckPriceLink = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputCheckPriceLink"');
    return ListOutputCheckPriceLink_possibleTypes.includes(obj.__typename);
};
var CountersCheckPriceLink_possibleTypes = ['CountersCheckPriceLink'];
export var isCountersCheckPriceLink = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersCheckPriceLink"');
    return CountersCheckPriceLink_possibleTypes.includes(obj.__typename);
};
var ItemOutputCheckPriceLink_possibleTypes = ['ItemOutputCheckPriceLink'];
export var isItemOutputCheckPriceLink = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputCheckPriceLink"');
    return ItemOutputCheckPriceLink_possibleTypes.includes(obj.__typename);
};
var CheckPriceLinkHistory_possibleTypes = ['CheckPriceLinkHistory'];
export var isCheckPriceLinkHistory = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCheckPriceLinkHistory"');
    return CheckPriceLinkHistory_possibleTypes.includes(obj.__typename);
};
var ListProductCategory_possibleTypes = ['ListProductCategory'];
export var isListProductCategory = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListProductCategory"');
    return ListProductCategory_possibleTypes.includes(obj.__typename);
};
var ListOutputProductCategory_possibleTypes = ['ListOutputProductCategory'];
export var isListOutputProductCategory = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputProductCategory"');
    return ListOutputProductCategory_possibleTypes.includes(obj.__typename);
};
var CountersProductCategory_possibleTypes = ['CountersProductCategory'];
export var isCountersProductCategory = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersProductCategory"');
    return CountersProductCategory_possibleTypes.includes(obj.__typename);
};
var ItemOutputProductCategory_possibleTypes = ['ItemOutputProductCategory'];
export var isItemOutputProductCategory = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputProductCategory"');
    return ItemOutputProductCategory_possibleTypes.includes(obj.__typename);
};
var CommonProductCategory_possibleTypes = ['CommonProductCategory'];
export var isCommonProductCategory = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCommonProductCategory"');
    return CommonProductCategory_possibleTypes.includes(obj.__typename);
};
var ListProductCategoryMovements_possibleTypes = ['ListProductCategoryMovements'];
export var isListProductCategoryMovements = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListProductCategoryMovements"');
    return ListProductCategoryMovements_possibleTypes.includes(obj.__typename);
};
var ProductCategoryMovementItem_possibleTypes = ['ProductCategoryMovementItem'];
export var isProductCategoryMovementItem = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isProductCategoryMovementItem"');
    return ProductCategoryMovementItem_possibleTypes.includes(obj.__typename);
};
var CountersProductCategoryMovements_possibleTypes = ['CountersProductCategoryMovements'];
export var isCountersProductCategoryMovements = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersProductCategoryMovements"');
    return CountersProductCategoryMovements_possibleTypes.includes(obj.__typename);
};
var ListProductBrandMovements_possibleTypes = ['ListProductBrandMovements'];
export var isListProductBrandMovements = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListProductBrandMovements"');
    return ListProductBrandMovements_possibleTypes.includes(obj.__typename);
};
var ProductBrandMovementItem_possibleTypes = ['ProductBrandMovementItem'];
export var isProductBrandMovementItem = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isProductBrandMovementItem"');
    return ProductBrandMovementItem_possibleTypes.includes(obj.__typename);
};
var CountersProductBrandMovements_possibleTypes = ['CountersProductBrandMovements'];
export var isCountersProductBrandMovements = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersProductBrandMovements"');
    return CountersProductBrandMovements_possibleTypes.includes(obj.__typename);
};
var ListProductMovements_possibleTypes = ['ListProductMovements'];
export var isListProductMovements = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListProductMovements"');
    return ListProductMovements_possibleTypes.includes(obj.__typename);
};
var ProductMovementItem_possibleTypes = ['ProductMovementItem'];
export var isProductMovementItem = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isProductMovementItem"');
    return ProductMovementItem_possibleTypes.includes(obj.__typename);
};
var CountersProductMovements_possibleTypes = ['CountersProductMovements'];
export var isCountersProductMovements = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersProductMovements"');
    return CountersProductMovements_possibleTypes.includes(obj.__typename);
};
var ListStorageMovements_possibleTypes = ['ListStorageMovements'];
export var isListStorageMovements = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListStorageMovements"');
    return ListStorageMovements_possibleTypes.includes(obj.__typename);
};
var StorageMovementItem_possibleTypes = ['StorageMovementItem'];
export var isStorageMovementItem = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isStorageMovementItem"');
    return StorageMovementItem_possibleTypes.includes(obj.__typename);
};
var CountersStorageMovements_possibleTypes = ['CountersStorageMovements'];
export var isCountersStorageMovements = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersStorageMovements"');
    return CountersStorageMovements_possibleTypes.includes(obj.__typename);
};
var ListStorageDocuments_possibleTypes = ['ListStorageDocuments'];
export var isListStorageDocuments = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListStorageDocuments"');
    return ListStorageDocuments_possibleTypes.includes(obj.__typename);
};
var ListOutputStorageDocuments_possibleTypes = ['ListOutputStorageDocuments'];
export var isListOutputStorageDocuments = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputStorageDocuments"');
    return ListOutputStorageDocuments_possibleTypes.includes(obj.__typename);
};
var StorageDocumentsProductOutput_possibleTypes = ['StorageDocumentsProductOutput'];
export var isStorageDocumentsProductOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isStorageDocumentsProductOutput"');
    return StorageDocumentsProductOutput_possibleTypes.includes(obj.__typename);
};
var StorageDocumentsProductSet_possibleTypes = ['StorageDocumentsProductSet'];
export var isStorageDocumentsProductSet = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isStorageDocumentsProductSet"');
    return StorageDocumentsProductSet_possibleTypes.includes(obj.__typename);
};
var CountersStorageDocuments_possibleTypes = ['CountersStorageDocuments'];
export var isCountersStorageDocuments = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersStorageDocuments"');
    return CountersStorageDocuments_possibleTypes.includes(obj.__typename);
};
var ItemOutputStorageDocuments_possibleTypes = ['ItemOutputStorageDocuments'];
export var isItemOutputStorageDocuments = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputStorageDocuments"');
    return ItemOutputStorageDocuments_possibleTypes.includes(obj.__typename);
};
var StorageOutput_possibleTypes = ['StorageOutput'];
export var isStorageOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isStorageOutput"');
    return StorageOutput_possibleTypes.includes(obj.__typename);
};
var LinkedDocuments_possibleTypes = ['LinkedDocuments'];
export var isLinkedDocuments = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isLinkedDocuments"');
    return LinkedDocuments_possibleTypes.includes(obj.__typename);
};
var ListStorageShipments_possibleTypes = ['ListStorageShipments'];
export var isListStorageShipments = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListStorageShipments"');
    return ListStorageShipments_possibleTypes.includes(obj.__typename);
};
var ListOutputStorageShipments_possibleTypes = ['ListOutputStorageShipments'];
export var isListOutputStorageShipments = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputStorageShipments"');
    return ListOutputStorageShipments_possibleTypes.includes(obj.__typename);
};
var StorageShipmentsProductOutput_possibleTypes = ['StorageShipmentsProductOutput'];
export var isStorageShipmentsProductOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isStorageShipmentsProductOutput"');
    return StorageShipmentsProductOutput_possibleTypes.includes(obj.__typename);
};
var CountersStorageShipments_possibleTypes = ['CountersStorageShipments'];
export var isCountersStorageShipments = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersStorageShipments"');
    return CountersStorageShipments_possibleTypes.includes(obj.__typename);
};
var ItemOutputStorageShipments_possibleTypes = ['ItemOutputStorageShipments'];
export var isItemOutputStorageShipments = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputStorageShipments"');
    return ItemOutputStorageShipments_possibleTypes.includes(obj.__typename);
};
var LinkedDocumentsStorageShipments_possibleTypes = ['LinkedDocumentsStorageShipments'];
export var isLinkedDocumentsStorageShipments = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isLinkedDocumentsStorageShipments"');
    return LinkedDocumentsStorageShipments_possibleTypes.includes(obj.__typename);
};
var InitDeliverStorageShipments_possibleTypes = ['InitDeliverStorageShipments'];
export var isInitDeliverStorageShipments = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isInitDeliverStorageShipments"');
    return InitDeliverStorageShipments_possibleTypes.includes(obj.__typename);
};
var DeliverProducts_possibleTypes = ['DeliverProducts'];
export var isDeliverProducts = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isDeliverProducts"');
    return DeliverProducts_possibleTypes.includes(obj.__typename);
};
var InitPayStorageShipments_possibleTypes = ['InitPayStorageShipments'];
export var isInitPayStorageShipments = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isInitPayStorageShipments"');
    return InitPayStorageShipments_possibleTypes.includes(obj.__typename);
};
var ListI18nLang_possibleTypes = ['ListI18nLang'];
export var isListI18nLang = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListI18nLang"');
    return ListI18nLang_possibleTypes.includes(obj.__typename);
};
var ItemI18nLang_possibleTypes = ['ItemI18nLang'];
export var isItemI18nLang = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemI18nLang"');
    return ItemI18nLang_possibleTypes.includes(obj.__typename);
};
var CountersI18nLang_possibleTypes = ['CountersI18nLang'];
export var isCountersI18nLang = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersI18nLang"');
    return CountersI18nLang_possibleTypes.includes(obj.__typename);
};
var InitTranslations_possibleTypes = ['InitTranslations'];
export var isInitTranslations = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isInitTranslations"');
    return InitTranslations_possibleTypes.includes(obj.__typename);
};
var ListI18nKey_possibleTypes = ['ListI18nKey'];
export var isListI18nKey = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListI18nKey"');
    return ListI18nKey_possibleTypes.includes(obj.__typename);
};
var ItemI18nKey_possibleTypes = ['ItemI18nKey'];
export var isItemI18nKey = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemI18nKey"');
    return ItemI18nKey_possibleTypes.includes(obj.__typename);
};
var I18nLangOutput_possibleTypes = ['I18nLangOutput'];
export var isI18nLangOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isI18nLangOutput"');
    return I18nLangOutput_possibleTypes.includes(obj.__typename);
};
var CountersI18nKey_possibleTypes = ['CountersI18nKey'];
export var isCountersI18nKey = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersI18nKey"');
    return CountersI18nKey_possibleTypes.includes(obj.__typename);
};
var InitSmartEditI18nKey_possibleTypes = ['InitSmartEditI18nKey'];
export var isInitSmartEditI18nKey = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isInitSmartEditI18nKey"');
    return InitSmartEditI18nKey_possibleTypes.includes(obj.__typename);
};
var InitSmartEditItemI18nKey_possibleTypes = ['InitSmartEditItemI18nKey'];
export var isInitSmartEditItemI18nKey = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isInitSmartEditItemI18nKey"');
    return InitSmartEditItemI18nKey_possibleTypes.includes(obj.__typename);
};
var ListAccount_possibleTypes = ['ListAccount'];
export var isListAccount = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListAccount"');
    return ListAccount_possibleTypes.includes(obj.__typename);
};
var ListOutputAccount_possibleTypes = ['ListOutputAccount'];
export var isListOutputAccount = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputAccount"');
    return ListOutputAccount_possibleTypes.includes(obj.__typename);
};
var CountersAccount_possibleTypes = ['CountersAccount'];
export var isCountersAccount = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersAccount"');
    return CountersAccount_possibleTypes.includes(obj.__typename);
};
var ItemOutputAccount_possibleTypes = ['ItemOutputAccount'];
export var isItemOutputAccount = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputAccount"');
    return ItemOutputAccount_possibleTypes.includes(obj.__typename);
};
var ListAccountMovements_possibleTypes = ['ListAccountMovements'];
export var isListAccountMovements = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListAccountMovements"');
    return ListAccountMovements_possibleTypes.includes(obj.__typename);
};
var AccountMovementItem_possibleTypes = ['AccountMovementItem'];
export var isAccountMovementItem = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isAccountMovementItem"');
    return AccountMovementItem_possibleTypes.includes(obj.__typename);
};
var CountersAccountMovements_possibleTypes = ['CountersAccountMovements'];
export var isCountersAccountMovements = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersAccountMovements"');
    return CountersAccountMovements_possibleTypes.includes(obj.__typename);
};
var ListTransactionArticles_possibleTypes = ['ListTransactionArticles'];
export var isListTransactionArticles = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListTransactionArticles"');
    return ListTransactionArticles_possibleTypes.includes(obj.__typename);
};
var ListOutputTransactionArticles_possibleTypes = ['ListOutputTransactionArticles'];
export var isListOutputTransactionArticles = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputTransactionArticles"');
    return ListOutputTransactionArticles_possibleTypes.includes(obj.__typename);
};
var CountersTransactionArticles_possibleTypes = ['CountersTransactionArticles'];
export var isCountersTransactionArticles = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersTransactionArticles"');
    return CountersTransactionArticles_possibleTypes.includes(obj.__typename);
};
var ItemOutputTransactionArticles_possibleTypes = ['ItemOutputTransactionArticles'];
export var isItemOutputTransactionArticles = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputTransactionArticles"');
    return ItemOutputTransactionArticles_possibleTypes.includes(obj.__typename);
};
var ListTransactionArticlesMovements_possibleTypes = ['ListTransactionArticlesMovements'];
export var isListTransactionArticlesMovements = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListTransactionArticlesMovements"');
    return ListTransactionArticlesMovements_possibleTypes.includes(obj.__typename);
};
var TransactionArticlesMovementItem_possibleTypes = ['TransactionArticlesMovementItem'];
export var isTransactionArticlesMovementItem = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isTransactionArticlesMovementItem"');
    return TransactionArticlesMovementItem_possibleTypes.includes(obj.__typename);
};
var CountersTransactionArticlesMovements_possibleTypes = ['CountersTransactionArticlesMovements'];
export var isCountersTransactionArticlesMovements = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersTransactionArticlesMovements"');
    return CountersTransactionArticlesMovements_possibleTypes.includes(obj.__typename);
};
var ListTransactions_possibleTypes = ['ListTransactions'];
export var isListTransactions = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListTransactions"');
    return ListTransactions_possibleTypes.includes(obj.__typename);
};
var ListOutputTransactions_possibleTypes = ['ListOutputTransactions'];
export var isListOutputTransactions = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputTransactions"');
    return ListOutputTransactions_possibleTypes.includes(obj.__typename);
};
var CountersTransactions_possibleTypes = ['CountersTransactions'];
export var isCountersTransactions = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersTransactions"');
    return CountersTransactions_possibleTypes.includes(obj.__typename);
};
var ItemOutputTransactions_possibleTypes = ['ItemOutputTransactions'];
export var isItemOutputTransactions = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputTransactions"');
    return ItemOutputTransactions_possibleTypes.includes(obj.__typename);
};
var TransactionArticlesOutput_possibleTypes = ['TransactionArticlesOutput'];
export var isTransactionArticlesOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isTransactionArticlesOutput"');
    return TransactionArticlesOutput_possibleTypes.includes(obj.__typename);
};
var AccountOutput_possibleTypes = ['AccountOutput'];
export var isAccountOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isAccountOutput"');
    return AccountOutput_possibleTypes.includes(obj.__typename);
};
var ListSales_possibleTypes = ['ListSales'];
export var isListSales = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListSales"');
    return ListSales_possibleTypes.includes(obj.__typename);
};
var ListOutputSales_possibleTypes = ['ListOutputSales'];
export var isListOutputSales = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputSales"');
    return ListOutputSales_possibleTypes.includes(obj.__typename);
};
var SourceOrdersOutput_possibleTypes = ['SourceOrdersOutput'];
export var isSourceOrdersOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isSourceOrdersOutput"');
    return SourceOrdersOutput_possibleTypes.includes(obj.__typename);
};
var SalesProductOutput_possibleTypes = ['SalesProductOutput'];
export var isSalesProductOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isSalesProductOutput"');
    return SalesProductOutput_possibleTypes.includes(obj.__typename);
};
var CountersSales_possibleTypes = ['CountersSales'];
export var isCountersSales = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersSales"');
    return CountersSales_possibleTypes.includes(obj.__typename);
};
var ItemOutputSales_possibleTypes = ['ItemOutputSales'];
export var isItemOutputSales = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputSales"');
    return ItemOutputSales_possibleTypes.includes(obj.__typename);
};
var LinkedDocumentsSales_possibleTypes = ['LinkedDocumentsSales'];
export var isLinkedDocumentsSales = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isLinkedDocumentsSales"');
    return LinkedDocumentsSales_possibleTypes.includes(obj.__typename);
};
var DeliveryServicesOutput_possibleTypes = ['DeliveryServicesOutput'];
export var isDeliveryServicesOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isDeliveryServicesOutput"');
    return DeliveryServicesOutput_possibleTypes.includes(obj.__typename);
};
var InitDeliverSales_possibleTypes = ['InitDeliverSales'];
export var isInitDeliverSales = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isInitDeliverSales"');
    return InitDeliverSales_possibleTypes.includes(obj.__typename);
};
var DeliverSalesProducts_possibleTypes = ['DeliverSalesProducts'];
export var isDeliverSalesProducts = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isDeliverSalesProducts"');
    return DeliverSalesProducts_possibleTypes.includes(obj.__typename);
};
var InitPaySales_possibleTypes = ['InitPaySales'];
export var isInitPaySales = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isInitPaySales"');
    return InitPaySales_possibleTypes.includes(obj.__typename);
};
var ListSourceOrders_possibleTypes = ['ListSourceOrders'];
export var isListSourceOrders = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListSourceOrders"');
    return ListSourceOrders_possibleTypes.includes(obj.__typename);
};
var ListOutputSourceOrders_possibleTypes = ['ListOutputSourceOrders'];
export var isListOutputSourceOrders = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputSourceOrders"');
    return ListOutputSourceOrders_possibleTypes.includes(obj.__typename);
};
var CountersSourceOrders_possibleTypes = ['CountersSourceOrders'];
export var isCountersSourceOrders = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersSourceOrders"');
    return CountersSourceOrders_possibleTypes.includes(obj.__typename);
};
var ItemOutputSourceOrders_possibleTypes = ['ItemOutputSourceOrders'];
export var isItemOutputSourceOrders = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputSourceOrders"');
    return ItemOutputSourceOrders_possibleTypes.includes(obj.__typename);
};
var ListSourceOrdersMovements_possibleTypes = ['ListSourceOrdersMovements'];
export var isListSourceOrdersMovements = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListSourceOrdersMovements"');
    return ListSourceOrdersMovements_possibleTypes.includes(obj.__typename);
};
var SourceOrdersMovementItem_possibleTypes = ['SourceOrdersMovementItem'];
export var isSourceOrdersMovementItem = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isSourceOrdersMovementItem"');
    return SourceOrdersMovementItem_possibleTypes.includes(obj.__typename);
};
var CountersSourceOrdersMovements_possibleTypes = ['CountersSourceOrdersMovements'];
export var isCountersSourceOrdersMovements = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersSourceOrdersMovements"');
    return CountersSourceOrdersMovements_possibleTypes.includes(obj.__typename);
};
var ListDeliveryServicesMovements_possibleTypes = ['ListDeliveryServicesMovements'];
export var isListDeliveryServicesMovements = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListDeliveryServicesMovements"');
    return ListDeliveryServicesMovements_possibleTypes.includes(obj.__typename);
};
var DeliveryServicesMovementItem_possibleTypes = ['DeliveryServicesMovementItem'];
export var isDeliveryServicesMovementItem = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isDeliveryServicesMovementItem"');
    return DeliveryServicesMovementItem_possibleTypes.includes(obj.__typename);
};
var CountersDeliveryServicesMovements_possibleTypes = ['CountersDeliveryServicesMovements'];
export var isCountersDeliveryServicesMovements = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersDeliveryServicesMovements"');
    return CountersDeliveryServicesMovements_possibleTypes.includes(obj.__typename);
};
var ListDeliveryServices_possibleTypes = ['ListDeliveryServices'];
export var isListDeliveryServices = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListDeliveryServices"');
    return ListDeliveryServices_possibleTypes.includes(obj.__typename);
};
var ListOutputDeliveryServices_possibleTypes = ['ListOutputDeliveryServices'];
export var isListOutputDeliveryServices = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputDeliveryServices"');
    return ListOutputDeliveryServices_possibleTypes.includes(obj.__typename);
};
var CountersDeliveryServices_possibleTypes = ['CountersDeliveryServices'];
export var isCountersDeliveryServices = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersDeliveryServices"');
    return CountersDeliveryServices_possibleTypes.includes(obj.__typename);
};
var ItemOutputDeliveryServices_possibleTypes = ['ItemOutputDeliveryServices'];
export var isItemOutputDeliveryServices = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputDeliveryServices"');
    return ItemOutputDeliveryServices_possibleTypes.includes(obj.__typename);
};
var ListSitesScroller_possibleTypes = ['ListSitesScroller'];
export var isListSitesScroller = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListSitesScroller"');
    return ListSitesScroller_possibleTypes.includes(obj.__typename);
};
var ListOutputSitesScroller_possibleTypes = ['ListOutputSitesScroller'];
export var isListOutputSitesScroller = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputSitesScroller"');
    return ListOutputSitesScroller_possibleTypes.includes(obj.__typename);
};
var CountersSitesScroller_possibleTypes = ['CountersSitesScroller'];
export var isCountersSitesScroller = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersSitesScroller"');
    return CountersSitesScroller_possibleTypes.includes(obj.__typename);
};
var ItemOutputSitesScroller_possibleTypes = ['ItemOutputSitesScroller'];
export var isItemOutputSitesScroller = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputSitesScroller"');
    return ItemOutputSitesScroller_possibleTypes.includes(obj.__typename);
};
var ListSitesPages_possibleTypes = ['ListSitesPages'];
export var isListSitesPages = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListSitesPages"');
    return ListSitesPages_possibleTypes.includes(obj.__typename);
};
var ListOutputSitesPages_possibleTypes = ['ListOutputSitesPages'];
export var isListOutputSitesPages = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputSitesPages"');
    return ListOutputSitesPages_possibleTypes.includes(obj.__typename);
};
var CountersSitesPages_possibleTypes = ['CountersSitesPages'];
export var isCountersSitesPages = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersSitesPages"');
    return CountersSitesPages_possibleTypes.includes(obj.__typename);
};
var ItemOutputSitesPages_possibleTypes = ['ItemOutputSitesPages'];
export var isItemOutputSitesPages = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputSitesPages"');
    return ItemOutputSitesPages_possibleTypes.includes(obj.__typename);
};
var InitSmartEditSitesPages_possibleTypes = ['InitSmartEditSitesPages'];
export var isInitSmartEditSitesPages = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isInitSmartEditSitesPages"');
    return InitSmartEditSitesPages_possibleTypes.includes(obj.__typename);
};
var InitSmartEditPageItem_possibleTypes = ['InitSmartEditPageItem'];
export var isInitSmartEditPageItem = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isInitSmartEditPageItem"');
    return InitSmartEditPageItem_possibleTypes.includes(obj.__typename);
};
var ListSitesNews_possibleTypes = ['ListSitesNews'];
export var isListSitesNews = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListSitesNews"');
    return ListSitesNews_possibleTypes.includes(obj.__typename);
};
var ListOutputSitesNews_possibleTypes = ['ListOutputSitesNews'];
export var isListOutputSitesNews = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputSitesNews"');
    return ListOutputSitesNews_possibleTypes.includes(obj.__typename);
};
var CountersSitesNews_possibleTypes = ['CountersSitesNews'];
export var isCountersSitesNews = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersSitesNews"');
    return CountersSitesNews_possibleTypes.includes(obj.__typename);
};
var ItemOutputSitesNews_possibleTypes = ['ItemOutputSitesNews'];
export var isItemOutputSitesNews = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputSitesNews"');
    return ItemOutputSitesNews_possibleTypes.includes(obj.__typename);
};
var ListSitesShopCategories_possibleTypes = ['ListSitesShopCategories'];
export var isListSitesShopCategories = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListSitesShopCategories"');
    return ListSitesShopCategories_possibleTypes.includes(obj.__typename);
};
var ListOutputSitesShopCategories_possibleTypes = ['ListOutputSitesShopCategories'];
export var isListOutputSitesShopCategories = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputSitesShopCategories"');
    return ListOutputSitesShopCategories_possibleTypes.includes(obj.__typename);
};
var SitesShopCategoriesOutput_possibleTypes = ['SitesShopCategoriesOutput'];
export var isSitesShopCategoriesOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isSitesShopCategoriesOutput"');
    return SitesShopCategoriesOutput_possibleTypes.includes(obj.__typename);
};
var CountersSitesShopCategories_possibleTypes = ['CountersSitesShopCategories'];
export var isCountersSitesShopCategories = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersSitesShopCategories"');
    return CountersSitesShopCategories_possibleTypes.includes(obj.__typename);
};
var ItemOutputSitesShopCategories_possibleTypes = ['ItemOutputSitesShopCategories'];
export var isItemOutputSitesShopCategories = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputSitesShopCategories"');
    return ItemOutputSitesShopCategories_possibleTypes.includes(obj.__typename);
};
var InitSmartEditSitesShopCategories_possibleTypes = ['InitSmartEditSitesShopCategories'];
export var isInitSmartEditSitesShopCategories = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isInitSmartEditSitesShopCategories"');
    return InitSmartEditSitesShopCategories_possibleTypes.includes(obj.__typename);
};
var InitSmartEditCategoryItem_possibleTypes = ['InitSmartEditCategoryItem'];
export var isInitSmartEditCategoryItem = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isInitSmartEditCategoryItem"');
    return InitSmartEditCategoryItem_possibleTypes.includes(obj.__typename);
};
var ListSitesShopProducts_possibleTypes = ['ListSitesShopProducts'];
export var isListSitesShopProducts = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListSitesShopProducts"');
    return ListSitesShopProducts_possibleTypes.includes(obj.__typename);
};
var ListOutputSitesShopProducts_possibleTypes = ['ListOutputSitesShopProducts'];
export var isListOutputSitesShopProducts = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputSitesShopProducts"');
    return ListOutputSitesShopProducts_possibleTypes.includes(obj.__typename);
};
var ExtendSimpleProductForSitesShopProducts_possibleTypes = ['ExtendSimpleProductForSitesShopProducts'];
export var isExtendSimpleProductForSitesShopProducts = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isExtendSimpleProductForSitesShopProducts"');
    return ExtendSimpleProductForSitesShopProducts_possibleTypes.includes(obj.__typename);
};
var ProductSetItem_possibleTypes = ['ProductSetItem'];
export var isProductSetItem = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isProductSetItem"');
    return ProductSetItem_possibleTypes.includes(obj.__typename);
};
var CountersSitesShopProducts_possibleTypes = ['CountersSitesShopProducts'];
export var isCountersSitesShopProducts = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersSitesShopProducts"');
    return CountersSitesShopProducts_possibleTypes.includes(obj.__typename);
};
var ItemOutputSitesShopProducts_possibleTypes = ['ItemOutputSitesShopProducts'];
export var isItemOutputSitesShopProducts = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputSitesShopProducts"');
    return ItemOutputSitesShopProducts_possibleTypes.includes(obj.__typename);
};
var InitSmartEditSitesShopProducts_possibleTypes = ['InitSmartEditSitesShopProducts'];
export var isInitSmartEditSitesShopProducts = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isInitSmartEditSitesShopProducts"');
    return InitSmartEditSitesShopProducts_possibleTypes.includes(obj.__typename);
};
var InitSmartEditProductItem_possibleTypes = ['InitSmartEditProductItem'];
export var isInitSmartEditProductItem = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isInitSmartEditProductItem"');
    return InitSmartEditProductItem_possibleTypes.includes(obj.__typename);
};
var ListSitesShopPayment_possibleTypes = ['ListSitesShopPayment'];
export var isListSitesShopPayment = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListSitesShopPayment"');
    return ListSitesShopPayment_possibleTypes.includes(obj.__typename);
};
var ListOutputSitesShopPayment_possibleTypes = ['ListOutputSitesShopPayment'];
export var isListOutputSitesShopPayment = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputSitesShopPayment"');
    return ListOutputSitesShopPayment_possibleTypes.includes(obj.__typename);
};
var CountersSitesShopPayment_possibleTypes = ['CountersSitesShopPayment'];
export var isCountersSitesShopPayment = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersSitesShopPayment"');
    return CountersSitesShopPayment_possibleTypes.includes(obj.__typename);
};
var ItemOutputSitesShopPayment_possibleTypes = ['ItemOutputSitesShopPayment'];
export var isItemOutputSitesShopPayment = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputSitesShopPayment"');
    return ItemOutputSitesShopPayment_possibleTypes.includes(obj.__typename);
};
var ListSitesShopDelivery_possibleTypes = ['ListSitesShopDelivery'];
export var isListSitesShopDelivery = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListSitesShopDelivery"');
    return ListSitesShopDelivery_possibleTypes.includes(obj.__typename);
};
var ListOutputSitesShopDelivery_possibleTypes = ['ListOutputSitesShopDelivery'];
export var isListOutputSitesShopDelivery = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputSitesShopDelivery"');
    return ListOutputSitesShopDelivery_possibleTypes.includes(obj.__typename);
};
var CountersSitesShopDelivery_possibleTypes = ['CountersSitesShopDelivery'];
export var isCountersSitesShopDelivery = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersSitesShopDelivery"');
    return CountersSitesShopDelivery_possibleTypes.includes(obj.__typename);
};
var ItemOutputSitesShopDelivery_possibleTypes = ['ItemOutputSitesShopDelivery'];
export var isItemOutputSitesShopDelivery = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputSitesShopDelivery"');
    return ItemOutputSitesShopDelivery_possibleTypes.includes(obj.__typename);
};
var ResolverItemOutput_possibleTypes = ['ResolverItemOutput'];
export var isResolverItemOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isResolverItemOutput"');
    return ResolverItemOutput_possibleTypes.includes(obj.__typename);
};
var ListGroups_possibleTypes = ['ListGroups'];
export var isListGroups = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListGroups"');
    return ListGroups_possibleTypes.includes(obj.__typename);
};
var ListOutputGroups_possibleTypes = ['ListOutputGroups'];
export var isListOutputGroups = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputGroups"');
    return ListOutputGroups_possibleTypes.includes(obj.__typename);
};
var CountersGroups_possibleTypes = ['CountersGroups'];
export var isCountersGroups = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersGroups"');
    return CountersGroups_possibleTypes.includes(obj.__typename);
};
var ItemOutputGroups_possibleTypes = ['ItemOutputGroups'];
export var isItemOutputGroups = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputGroups"');
    return ItemOutputGroups_possibleTypes.includes(obj.__typename);
};
var ListProcurementSupplier_possibleTypes = ['ListProcurementSupplier'];
export var isListProcurementSupplier = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListProcurementSupplier"');
    return ListProcurementSupplier_possibleTypes.includes(obj.__typename);
};
var ItemProcurementSupplier_possibleTypes = ['ItemProcurementSupplier'];
export var isItemProcurementSupplier = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemProcurementSupplier"');
    return ItemProcurementSupplier_possibleTypes.includes(obj.__typename);
};
var CountersProcurementSupplier_possibleTypes = ['CountersProcurementSupplier'];
export var isCountersProcurementSupplier = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersProcurementSupplier"');
    return CountersProcurementSupplier_possibleTypes.includes(obj.__typename);
};
var ListProcurementRequest_possibleTypes = ['ListProcurementRequest'];
export var isListProcurementRequest = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListProcurementRequest"');
    return ListProcurementRequest_possibleTypes.includes(obj.__typename);
};
var ItemOutputProcurementRequest_possibleTypes = ['ItemOutputProcurementRequest'];
export var isItemOutputProcurementRequest = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputProcurementRequest"');
    return ItemOutputProcurementRequest_possibleTypes.includes(obj.__typename);
};
var ProcurementSupplierOutput_possibleTypes = ['ProcurementSupplierOutput'];
export var isProcurementSupplierOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isProcurementSupplierOutput"');
    return ProcurementSupplierOutput_possibleTypes.includes(obj.__typename);
};
var ProcurementContractOutput_possibleTypes = ['ProcurementContractOutput'];
export var isProcurementContractOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isProcurementContractOutput"');
    return ProcurementContractOutput_possibleTypes.includes(obj.__typename);
};
var ItemOutputProcurementRequestItem_possibleTypes = ['ItemOutputProcurementRequestItem'];
export var isItemOutputProcurementRequestItem = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputProcurementRequestItem"');
    return ItemOutputProcurementRequestItem_possibleTypes.includes(obj.__typename);
};
var ProductRefOutput_possibleTypes = ['ProductRefOutput'];
export var isProductRefOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isProductRefOutput"');
    return ProductRefOutput_possibleTypes.includes(obj.__typename);
};
var ItemOutputProcurementRequestExpense_possibleTypes = ['ItemOutputProcurementRequestExpense'];
export var isItemOutputProcurementRequestExpense = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputProcurementRequestExpense"');
    return ItemOutputProcurementRequestExpense_possibleTypes.includes(obj.__typename);
};
var CountersProcurementRequest_possibleTypes = ['CountersProcurementRequest'];
export var isCountersProcurementRequest = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersProcurementRequest"');
    return CountersProcurementRequest_possibleTypes.includes(obj.__typename);
};
var ListProcurementContract_possibleTypes = ['ListProcurementContract'];
export var isListProcurementContract = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListProcurementContract"');
    return ListProcurementContract_possibleTypes.includes(obj.__typename);
};
var ListOutputProcurementContract_possibleTypes = ['ListOutputProcurementContract'];
export var isListOutputProcurementContract = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputProcurementContract"');
    return ListOutputProcurementContract_possibleTypes.includes(obj.__typename);
};
var ProcurementRequestOutput_possibleTypes = ['ProcurementRequestOutput'];
export var isProcurementRequestOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isProcurementRequestOutput"');
    return ProcurementRequestOutput_possibleTypes.includes(obj.__typename);
};
var CountersProcurementContract_possibleTypes = ['CountersProcurementContract'];
export var isCountersProcurementContract = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersProcurementContract"');
    return CountersProcurementContract_possibleTypes.includes(obj.__typename);
};
var ItemOutputProcurementContract_possibleTypes = ['ItemOutputProcurementContract'];
export var isItemOutputProcurementContract = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputProcurementContract"');
    return ItemOutputProcurementContract_possibleTypes.includes(obj.__typename);
};
var ListProcurementDelivery_possibleTypes = ['ListProcurementDelivery'];
export var isListProcurementDelivery = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListProcurementDelivery"');
    return ListProcurementDelivery_possibleTypes.includes(obj.__typename);
};
var ItemOutputProcurementDelivery_possibleTypes = ['ItemOutputProcurementDelivery'];
export var isItemOutputProcurementDelivery = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputProcurementDelivery"');
    return ItemOutputProcurementDelivery_possibleTypes.includes(obj.__typename);
};
var ItemOutputProcurementDeliveryItem_possibleTypes = ['ItemOutputProcurementDeliveryItem'];
export var isItemOutputProcurementDeliveryItem = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputProcurementDeliveryItem"');
    return ItemOutputProcurementDeliveryItem_possibleTypes.includes(obj.__typename);
};
var ProductRefOutputProcurementDeliveryItem_possibleTypes = ['ProductRefOutputProcurementDeliveryItem'];
export var isProductRefOutputProcurementDeliveryItem = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isProductRefOutputProcurementDeliveryItem"');
    return ProductRefOutputProcurementDeliveryItem_possibleTypes.includes(obj.__typename);
};
var ItemOutputProcurementDeliveryItemComponent_possibleTypes = ['ItemOutputProcurementDeliveryItemComponent'];
export var isItemOutputProcurementDeliveryItemComponent = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputProcurementDeliveryItemComponent"');
    return ItemOutputProcurementDeliveryItemComponent_possibleTypes.includes(obj.__typename);
};
var ItemOutputProcurementDeliveryBox_possibleTypes = ['ItemOutputProcurementDeliveryBox'];
export var isItemOutputProcurementDeliveryBox = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputProcurementDeliveryBox"');
    return ItemOutputProcurementDeliveryBox_possibleTypes.includes(obj.__typename);
};
var ItemOutputProcurementDeliveryBoxItem_possibleTypes = ['ItemOutputProcurementDeliveryBoxItem'];
export var isItemOutputProcurementDeliveryBoxItem = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputProcurementDeliveryBoxItem"');
    return ItemOutputProcurementDeliveryBoxItem_possibleTypes.includes(obj.__typename);
};
var ItemOutputProcurementDeliveryExpense_possibleTypes = ['ItemOutputProcurementDeliveryExpense'];
export var isItemOutputProcurementDeliveryExpense = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputProcurementDeliveryExpense"');
    return ItemOutputProcurementDeliveryExpense_possibleTypes.includes(obj.__typename);
};
var CountersProcurementDelivery_possibleTypes = ['CountersProcurementDelivery'];
export var isCountersProcurementDelivery = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersProcurementDelivery"');
    return CountersProcurementDelivery_possibleTypes.includes(obj.__typename);
};
var AvailableRequestItemForDeliveryOutput_possibleTypes = ['AvailableRequestItemForDeliveryOutput'];
export var isAvailableRequestItemForDeliveryOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isAvailableRequestItemForDeliveryOutput"');
    return AvailableRequestItemForDeliveryOutput_possibleTypes.includes(obj.__typename);
};
var FillProductDataProcurementDelivery_possibleTypes = ['FillProductDataProcurementDelivery'];
export var isFillProductDataProcurementDelivery = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isFillProductDataProcurementDelivery"');
    return FillProductDataProcurementDelivery_possibleTypes.includes(obj.__typename);
};
var FillProductComponentProcurementDelivery_possibleTypes = ['FillProductComponentProcurementDelivery'];
export var isFillProductComponentProcurementDelivery = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isFillProductComponentProcurementDelivery"');
    return FillProductComponentProcurementDelivery_possibleTypes.includes(obj.__typename);
};
var ListDocumentTemplate_possibleTypes = ['ListDocumentTemplate'];
export var isListDocumentTemplate = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListDocumentTemplate"');
    return ListDocumentTemplate_possibleTypes.includes(obj.__typename);
};
var ItemDocumentTemplate_possibleTypes = ['ItemDocumentTemplate'];
export var isItemDocumentTemplate = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemDocumentTemplate"');
    return ItemDocumentTemplate_possibleTypes.includes(obj.__typename);
};
var CountersDocumentTemplate_possibleTypes = ['CountersDocumentTemplate'];
export var isCountersDocumentTemplate = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersDocumentTemplate"');
    return CountersDocumentTemplate_possibleTypes.includes(obj.__typename);
};
var ListOzonSellerAccount_possibleTypes = ['ListOzonSellerAccount'];
export var isListOzonSellerAccount = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOzonSellerAccount"');
    return ListOzonSellerAccount_possibleTypes.includes(obj.__typename);
};
var ListOutputOzonSellerAccount_possibleTypes = ['ListOutputOzonSellerAccount'];
export var isListOutputOzonSellerAccount = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputOzonSellerAccount"');
    return ListOutputOzonSellerAccount_possibleTypes.includes(obj.__typename);
};
var CountersOzonSellerAccount_possibleTypes = ['CountersOzonSellerAccount'];
export var isCountersOzonSellerAccount = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersOzonSellerAccount"');
    return CountersOzonSellerAccount_possibleTypes.includes(obj.__typename);
};
var ItemOutputOzonSellerAccount_possibleTypes = ['ItemOutputOzonSellerAccount'];
export var isItemOutputOzonSellerAccount = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputOzonSellerAccount"');
    return ItemOutputOzonSellerAccount_possibleTypes.includes(obj.__typename);
};
var ListOzonPosting_possibleTypes = ['ListOzonPosting'];
export var isListOzonPosting = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOzonPosting"');
    return ListOzonPosting_possibleTypes.includes(obj.__typename);
};
var ListOutputOzonPosting_possibleTypes = ['ListOutputOzonPosting'];
export var isListOutputOzonPosting = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputOzonPosting"');
    return ListOutputOzonPosting_possibleTypes.includes(obj.__typename);
};
var OzonSellerAccountShortOutput_possibleTypes = ['OzonSellerAccountShortOutput'];
export var isOzonSellerAccountShortOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isOzonSellerAccountShortOutput"');
    return OzonSellerAccountShortOutput_possibleTypes.includes(obj.__typename);
};
var OzonPostingProductOutput_possibleTypes = ['OzonPostingProductOutput'];
export var isOzonPostingProductOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isOzonPostingProductOutput"');
    return OzonPostingProductOutput_possibleTypes.includes(obj.__typename);
};
var CountersOzonPosting_possibleTypes = ['CountersOzonPosting'];
export var isCountersOzonPosting = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersOzonPosting"');
    return CountersOzonPosting_possibleTypes.includes(obj.__typename);
};
var ItemOutputOzonPosting_possibleTypes = ['ItemOutputOzonPosting'];
export var isItemOutputOzonPosting = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputOzonPosting"');
    return ItemOutputOzonPosting_possibleTypes.includes(obj.__typename);
};
var OzonPostingAccrualsOutput_possibleTypes = ['OzonPostingAccrualsOutput'];
export var isOzonPostingAccrualsOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isOzonPostingAccrualsOutput"');
    return OzonPostingAccrualsOutput_possibleTypes.includes(obj.__typename);
};
var OzonAccrualOperationOutput_possibleTypes = ['OzonAccrualOperationOutput'];
export var isOzonAccrualOperationOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isOzonAccrualOperationOutput"');
    return OzonAccrualOperationOutput_possibleTypes.includes(obj.__typename);
};
var OzonPostingAccrualsTotalsOutput_possibleTypes = ['OzonPostingAccrualsTotalsOutput'];
export var isOzonPostingAccrualsTotalsOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isOzonPostingAccrualsTotalsOutput"');
    return OzonPostingAccrualsTotalsOutput_possibleTypes.includes(obj.__typename);
};
var OzonPostingFinancialDataOutput_possibleTypes = ['OzonPostingFinancialDataOutput'];
export var isOzonPostingFinancialDataOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isOzonPostingFinancialDataOutput"');
    return OzonPostingFinancialDataOutput_possibleTypes.includes(obj.__typename);
};
var OzonPostingFinancialDataProductOutput_possibleTypes = ['OzonPostingFinancialDataProductOutput'];
export var isOzonPostingFinancialDataProductOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isOzonPostingFinancialDataProductOutput"');
    return OzonPostingFinancialDataProductOutput_possibleTypes.includes(obj.__typename);
};
var OzonPostingGetSyncRunListOutput_possibleTypes = ['OzonPostingGetSyncRunListOutput'];
export var isOzonPostingGetSyncRunListOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isOzonPostingGetSyncRunListOutput"');
    return OzonPostingGetSyncRunListOutput_possibleTypes.includes(obj.__typename);
};
var OzonPostingGetSyncRunOutput_possibleTypes = ['OzonPostingGetSyncRunOutput'];
export var isOzonPostingGetSyncRunOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isOzonPostingGetSyncRunOutput"');
    return OzonPostingGetSyncRunOutput_possibleTypes.includes(obj.__typename);
};
var OzonPostingGetSyncRunItemOutput_possibleTypes = ['OzonPostingGetSyncRunItemOutput'];
export var isOzonPostingGetSyncRunItemOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isOzonPostingGetSyncRunItemOutput"');
    return OzonPostingGetSyncRunItemOutput_possibleTypes.includes(obj.__typename);
};
var OzonPostingAutoSyncTaskOutput_possibleTypes = ['OzonPostingAutoSyncTaskOutput'];
export var isOzonPostingAutoSyncTaskOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isOzonPostingAutoSyncTaskOutput"');
    return OzonPostingAutoSyncTaskOutput_possibleTypes.includes(obj.__typename);
};
var ListWbSellerAccount_possibleTypes = ['ListWbSellerAccount'];
export var isListWbSellerAccount = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListWbSellerAccount"');
    return ListWbSellerAccount_possibleTypes.includes(obj.__typename);
};
var ListOutputWbSellerAccount_possibleTypes = ['ListOutputWbSellerAccount'];
export var isListOutputWbSellerAccount = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputWbSellerAccount"');
    return ListOutputWbSellerAccount_possibleTypes.includes(obj.__typename);
};
var CountersWbSellerAccount_possibleTypes = ['CountersWbSellerAccount'];
export var isCountersWbSellerAccount = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersWbSellerAccount"');
    return CountersWbSellerAccount_possibleTypes.includes(obj.__typename);
};
var ItemOutputWbSellerAccount_possibleTypes = ['ItemOutputWbSellerAccount'];
export var isItemOutputWbSellerAccount = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputWbSellerAccount"');
    return ItemOutputWbSellerAccount_possibleTypes.includes(obj.__typename);
};
var ListWbPosting_possibleTypes = ['ListWbPosting'];
export var isListWbPosting = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListWbPosting"');
    return ListWbPosting_possibleTypes.includes(obj.__typename);
};
var ListOutputWbPosting_possibleTypes = ['ListOutputWbPosting'];
export var isListOutputWbPosting = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputWbPosting"');
    return ListOutputWbPosting_possibleTypes.includes(obj.__typename);
};
var WbSellerAccountShortOutput_possibleTypes = ['WbSellerAccountShortOutput'];
export var isWbSellerAccountShortOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isWbSellerAccountShortOutput"');
    return WbSellerAccountShortOutput_possibleTypes.includes(obj.__typename);
};
var WbPostingProductOutput_possibleTypes = ['WbPostingProductOutput'];
export var isWbPostingProductOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isWbPostingProductOutput"');
    return WbPostingProductOutput_possibleTypes.includes(obj.__typename);
};
var CountersWbPosting_possibleTypes = ['CountersWbPosting'];
export var isCountersWbPosting = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersWbPosting"');
    return CountersWbPosting_possibleTypes.includes(obj.__typename);
};
var ItemOutputWbPosting_possibleTypes = ['ItemOutputWbPosting'];
export var isItemOutputWbPosting = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputWbPosting"');
    return ItemOutputWbPosting_possibleTypes.includes(obj.__typename);
};
var WbPostingAccrualsOutput_possibleTypes = ['WbPostingAccrualsOutput'];
export var isWbPostingAccrualsOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isWbPostingAccrualsOutput"');
    return WbPostingAccrualsOutput_possibleTypes.includes(obj.__typename);
};
var WbAccrualOperationOutput_possibleTypes = ['WbAccrualOperationOutput'];
export var isWbAccrualOperationOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isWbAccrualOperationOutput"');
    return WbAccrualOperationOutput_possibleTypes.includes(obj.__typename);
};
var WbPostingAccrualsTotalsOutput_possibleTypes = ['WbPostingAccrualsTotalsOutput'];
export var isWbPostingAccrualsTotalsOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isWbPostingAccrualsTotalsOutput"');
    return WbPostingAccrualsTotalsOutput_possibleTypes.includes(obj.__typename);
};
var WbPostingFinancialDataOutput_possibleTypes = ['WbPostingFinancialDataOutput'];
export var isWbPostingFinancialDataOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isWbPostingFinancialDataOutput"');
    return WbPostingFinancialDataOutput_possibleTypes.includes(obj.__typename);
};
var WbPostingGetSyncRunListOutput_possibleTypes = ['WbPostingGetSyncRunListOutput'];
export var isWbPostingGetSyncRunListOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isWbPostingGetSyncRunListOutput"');
    return WbPostingGetSyncRunListOutput_possibleTypes.includes(obj.__typename);
};
var WbPostingGetSyncRunOutput_possibleTypes = ['WbPostingGetSyncRunOutput'];
export var isWbPostingGetSyncRunOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isWbPostingGetSyncRunOutput"');
    return WbPostingGetSyncRunOutput_possibleTypes.includes(obj.__typename);
};
var WbPostingGetSyncRunItemOutput_possibleTypes = ['WbPostingGetSyncRunItemOutput'];
export var isWbPostingGetSyncRunItemOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isWbPostingGetSyncRunItemOutput"');
    return WbPostingGetSyncRunItemOutput_possibleTypes.includes(obj.__typename);
};
var WbPostingAutoSyncTaskOutput_possibleTypes = ['WbPostingAutoSyncTaskOutput'];
export var isWbPostingAutoSyncTaskOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isWbPostingAutoSyncTaskOutput"');
    return WbPostingAutoSyncTaskOutput_possibleTypes.includes(obj.__typename);
};
var ListWbCatalogProduct_possibleTypes = ['ListWbCatalogProduct'];
export var isListWbCatalogProduct = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListWbCatalogProduct"');
    return ListWbCatalogProduct_possibleTypes.includes(obj.__typename);
};
var ListOutputWbCatalogProduct_possibleTypes = ['ListOutputWbCatalogProduct'];
export var isListOutputWbCatalogProduct = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputWbCatalogProduct"');
    return ListOutputWbCatalogProduct_possibleTypes.includes(obj.__typename);
};
var WbCatalogSellerAccountShortOutput_possibleTypes = ['WbCatalogSellerAccountShortOutput'];
export var isWbCatalogSellerAccountShortOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isWbCatalogSellerAccountShortOutput"');
    return WbCatalogSellerAccountShortOutput_possibleTypes.includes(obj.__typename);
};
var CountersWbCatalogProduct_possibleTypes = ['CountersWbCatalogProduct'];
export var isCountersWbCatalogProduct = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersWbCatalogProduct"');
    return CountersWbCatalogProduct_possibleTypes.includes(obj.__typename);
};
var ItemOutputWbCatalogProduct_possibleTypes = ['ItemOutputWbCatalogProduct'];
export var isItemOutputWbCatalogProduct = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputWbCatalogProduct"');
    return ItemOutputWbCatalogProduct_possibleTypes.includes(obj.__typename);
};
var WbCatalogSyncRunListOutput_possibleTypes = ['WbCatalogSyncRunListOutput'];
export var isWbCatalogSyncRunListOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isWbCatalogSyncRunListOutput"');
    return WbCatalogSyncRunListOutput_possibleTypes.includes(obj.__typename);
};
var WbCatalogSyncRunOutput_possibleTypes = ['WbCatalogSyncRunOutput'];
export var isWbCatalogSyncRunOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isWbCatalogSyncRunOutput"');
    return WbCatalogSyncRunOutput_possibleTypes.includes(obj.__typename);
};
var WbCatalogAutoSyncTaskOutput_possibleTypes = ['WbCatalogAutoSyncTaskOutput'];
export var isWbCatalogAutoSyncTaskOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isWbCatalogAutoSyncTaskOutput"');
    return WbCatalogAutoSyncTaskOutput_possibleTypes.includes(obj.__typename);
};
var ListAvitoSellerAccount_possibleTypes = ['ListAvitoSellerAccount'];
export var isListAvitoSellerAccount = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListAvitoSellerAccount"');
    return ListAvitoSellerAccount_possibleTypes.includes(obj.__typename);
};
var ListOutputAvitoSellerAccount_possibleTypes = ['ListOutputAvitoSellerAccount'];
export var isListOutputAvitoSellerAccount = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputAvitoSellerAccount"');
    return ListOutputAvitoSellerAccount_possibleTypes.includes(obj.__typename);
};
var CountersAvitoSellerAccount_possibleTypes = ['CountersAvitoSellerAccount'];
export var isCountersAvitoSellerAccount = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersAvitoSellerAccount"');
    return CountersAvitoSellerAccount_possibleTypes.includes(obj.__typename);
};
var ItemOutputAvitoSellerAccount_possibleTypes = ['ItemOutputAvitoSellerAccount'];
export var isItemOutputAvitoSellerAccount = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputAvitoSellerAccount"');
    return ItemOutputAvitoSellerAccount_possibleTypes.includes(obj.__typename);
};
var ListAvitoPosting_possibleTypes = ['ListAvitoPosting'];
export var isListAvitoPosting = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListAvitoPosting"');
    return ListAvitoPosting_possibleTypes.includes(obj.__typename);
};
var ListOutputAvitoPosting_possibleTypes = ['ListOutputAvitoPosting'];
export var isListOutputAvitoPosting = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isListOutputAvitoPosting"');
    return ListOutputAvitoPosting_possibleTypes.includes(obj.__typename);
};
var AvitoSellerAccountShortOutput_possibleTypes = ['AvitoSellerAccountShortOutput'];
export var isAvitoSellerAccountShortOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isAvitoSellerAccountShortOutput"');
    return AvitoSellerAccountShortOutput_possibleTypes.includes(obj.__typename);
};
var AvitoPostingProductOutput_possibleTypes = ['AvitoPostingProductOutput'];
export var isAvitoPostingProductOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isAvitoPostingProductOutput"');
    return AvitoPostingProductOutput_possibleTypes.includes(obj.__typename);
};
var CountersAvitoPosting_possibleTypes = ['CountersAvitoPosting'];
export var isCountersAvitoPosting = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isCountersAvitoPosting"');
    return CountersAvitoPosting_possibleTypes.includes(obj.__typename);
};
var ItemOutputAvitoPosting_possibleTypes = ['ItemOutputAvitoPosting'];
export var isItemOutputAvitoPosting = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isItemOutputAvitoPosting"');
    return ItemOutputAvitoPosting_possibleTypes.includes(obj.__typename);
};
var AvitoPostingGetSyncRunListOutput_possibleTypes = ['AvitoPostingGetSyncRunListOutput'];
export var isAvitoPostingGetSyncRunListOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isAvitoPostingGetSyncRunListOutput"');
    return AvitoPostingGetSyncRunListOutput_possibleTypes.includes(obj.__typename);
};
var AvitoPostingGetSyncRunOutput_possibleTypes = ['AvitoPostingGetSyncRunOutput'];
export var isAvitoPostingGetSyncRunOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isAvitoPostingGetSyncRunOutput"');
    return AvitoPostingGetSyncRunOutput_possibleTypes.includes(obj.__typename);
};
var AvitoPostingGetSyncRunItemOutput_possibleTypes = ['AvitoPostingGetSyncRunItemOutput'];
export var isAvitoPostingGetSyncRunItemOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isAvitoPostingGetSyncRunItemOutput"');
    return AvitoPostingGetSyncRunItemOutput_possibleTypes.includes(obj.__typename);
};
var AvitoPostingAutoSyncTaskOutput_possibleTypes = ['AvitoPostingAutoSyncTaskOutput'];
export var isAvitoPostingAutoSyncTaskOutput = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isAvitoPostingAutoSyncTaskOutput"');
    return AvitoPostingAutoSyncTaskOutput_possibleTypes.includes(obj.__typename);
};
var Mutation_possibleTypes = ['Mutation'];
export var isMutation = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isMutation"');
    return Mutation_possibleTypes.includes(obj.__typename);
};
var LoginInfo_possibleTypes = ['LoginInfo'];
export var isLoginInfo = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isLoginInfo"');
    return LoginInfo_possibleTypes.includes(obj.__typename);
};
var ActionResult_possibleTypes = ['ActionResult'];
export var isActionResult = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isActionResult"');
    return ActionResult_possibleTypes.includes(obj.__typename);
};
var ImportResult_possibleTypes = ['ImportResult'];
export var isImportResult = function (obj) {
    if (!(obj === null || obj === void 0 ? void 0 : obj.__typename))
        throw new Error('__typename is missing in "isImportResult"');
    return ImportResult_possibleTypes.includes(obj.__typename);
};
export var enumBy = {
    asc: 'asc',
    desc: 'desc'
};
export var enumOrderUser = {
    displayName: 'displayName',
    role: 'role',
    verified: 'verified',
    status: 'status',
    updatedAt: 'updatedAt'
};
export var enumCategoriesUser = {
    all: 'all',
    active: 'active',
    banned: 'banned'
};
export var enumActionsUser = {
    ban: 'ban',
    unban: 'unban'
};
export var enumOrderStorage = {
    name: 'name',
    address: 'address',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesStorage = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsStorage = {
    gSheetsSync: 'gSheetsSync',
    deleteGSheetsSync: 'deleteGSheetsSync',
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumOrderProduct = {
    name: 'name',
    barcode: 'barcode',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesProduct = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsProduct = {
    gSheetsSync: 'gSheetsSync',
    deleteGSheetsSync: 'deleteGSheetsSync',
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete',
    addToSite: 'addToSite'
};
export var enumOrderProductBrand = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesProductBrand = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsProductBrand = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumOrderCheckPriceMonitor = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesCheckPriceMonitor = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsCheckPriceMonitor = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumOrderCheckPriceLink = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesCheckPriceLink = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsCheckPriceLink = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumOrderProductCategory = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesProductCategory = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsProductCategory = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumOrderProductCategoryMovements = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    count: 'count'
};
export var enumOrderProductBrandMovements = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    count: 'count'
};
export var enumOrderProductMovements = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    count: 'count'
};
export var enumOrderStorageMovements = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    count: 'count'
};
export var enumStorageDocumentsType = {
    in: 'in',
    out: 'out',
    move: 'move'
};
export var enumOrderStorageDocuments = {
    name: 'name',
    barcode: 'barcode',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesStorageDocuments = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsStorageDocuments = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete',
    gSheetsSync: 'gSheetsSync'
};
export var enumOrderStorageShipments = {
    documentNumber: 'documentNumber',
    documentDate: 'documentDate',
    totalPriceRub: 'totalPriceRub',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesStorageShipments = {
    working: 'working',
    active: 'active',
    inactive: 'inactive',
    all: 'all'
};
export var enumActionsStorageShipments = {
    activate: 'activate',
    work: 'work',
    pay: 'pay',
    deliver: 'deliver',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumOrderI18NLang = {
    name: 'name',
    barcode: 'barcode',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesI18NLang = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsI18NLang = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumOrderI18NKey = {
    key: 'key',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesI18NKey = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsI18NKey = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete',
    smartEdit: 'smartEdit'
};
export var enumOrderAccount = {
    name: 'name',
    barcode: 'barcode',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesAccount = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsAccount = {
    gSheetsSync: 'gSheetsSync',
    deleteGSheetsSync: 'deleteGSheetsSync',
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumOrderAccountMovements = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    amount: 'amount'
};
export var enumOrderTransactionArticles = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesTransactionArticles = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsTransactionArticles = {
    gSheetsSync: 'gSheetsSync',
    deleteGSheetsSync: 'deleteGSheetsSync',
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumOrderTransactionArticlesMovements = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    amount: 'amount'
};
export var enumOrderTransactions = {
    name: 'name',
    barcode: 'barcode',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesTransactions = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsTransactions = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete',
    gSheetsSync: 'gSheetsSync'
};
export var enumOrderSales = {
    documentNumber: 'documentNumber',
    documentDate: 'documentDate',
    totalPriceRub: 'totalPriceRub',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesSales = {
    working: 'working',
    active: 'active',
    return: 'return',
    inactive: 'inactive',
    all: 'all'
};
export var enumActionsSales = {
    activate: 'activate',
    work: 'work',
    pay: 'pay',
    deliver: 'deliver',
    deactivate: 'deactivate',
    delete: 'delete',
    gSheetsSync: 'gSheetsSync'
};
export var enumOrderSourceOrders = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesSourceOrders = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsSourceOrders = {
    gSheetsSync: 'gSheetsSync',
    deleteGSheetsSync: 'deleteGSheetsSync',
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumOrderSourceOrdersMovements = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    count: 'count'
};
export var enumOrderDeliveryServicesMovements = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    count: 'count'
};
export var enumOrderDeliveryServices = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesDeliveryServices = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsDeliveryServices = {
    gSheetsSync: 'gSheetsSync',
    deleteGSheetsSync: 'deleteGSheetsSync',
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumOrderSitesScroller = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesSitesScroller = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsSitesScroller = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete',
    build: 'build'
};
export var enumOrderSitesPages = {
    title: 'title',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesSitesPages = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsSitesPages = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete',
    smartEdit: 'smartEdit'
};
export var enumOrderSitesNews = {
    title: 'title',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesSitesNews = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsSitesNews = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumOrderSitesShopCategories = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesSitesShopCategories = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsSitesShopCategories = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete',
    smartEdit: 'smartEdit'
};
export var enumOrderSitesShopProducts = {
    name: 'name',
    price: 'price',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesSitesShopProducts = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsSitesShopProducts = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete',
    smartEdit: 'smartEdit'
};
export var enumOrderSitesShopPayment = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesSitesShopPayment = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsSitesShopPayment = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumOrderSitesShopDelivery = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesSitesShopDelivery = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsSitesShopDelivery = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumOrderGroups = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesGroups = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsGroups = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumCategoriesProcurementSupplier = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumOrderProcurementSupplier = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumActionsProcurementSupplier = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumOrderProcurementRequest = {
    documentNumber: 'documentNumber',
    documentDate: 'documentDate',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesProcurementRequest = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsProcurementRequest = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumCategoriesProcurementContract = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumOrderProcurementContract = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumActionsProcurementContract = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumOrderProcurementDelivery = {
    documentNumber: 'documentNumber',
    documentDate: 'documentDate',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesProcurementDelivery = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsProcurementDelivery = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete',
    createShipment: 'createShipment'
};
export var enumOrderDocumentTemplate = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesDocumentTemplate = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsDocumentTemplate = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete',
    downloadPdf: 'downloadPdf'
};
export var enumOrderOzonSellerAccount = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesOzonSellerAccount = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsOzonSellerAccount = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumSchemeOzonPosting = {
    fbs: 'fbs',
    fbo: 'fbo'
};
export var enumOrderOzonPosting = {
    postingNumber: 'postingNumber',
    status: 'status',
    inProcessAt: 'inProcessAt',
    shipmentDate: 'shipmentDate',
    syncedAt: 'syncedAt',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt'
};
export var enumCategoriesOzonPosting = {
    all: 'all',
    awaiting: 'awaiting',
    delivering: 'delivering',
    delivered: 'delivered',
    cancelled: 'cancelled'
};
export var enumActionsOzonPosting = {
    sync: 'sync'
};
export var enumOrderWbSellerAccount = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesWbSellerAccount = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsWbSellerAccount = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumSchemeWbPosting = {
    fbs: 'fbs',
    fbw: 'fbw'
};
export var enumOrderWbPosting = {
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    inProcessAt: 'inProcessAt'
};
export var enumCategoriesWbPosting = {
    all: 'all',
    awaiting: 'awaiting',
    delivering: 'delivering',
    delivered: 'delivered',
    cancelled: 'cancelled'
};
export var enumActionsWbPosting = {
    sync: 'sync'
};
export var enumOrderWbCatalogProduct = {
    title: 'title',
    nmId: 'nmId',
    syncedAt: 'syncedAt',
    updatedAt: 'updatedAt'
};
export var enumCategoriesWbCatalogProduct = {
    all: 'all',
    active: 'active',
    inactive: 'inactive'
};
export var enumActionsWbCatalogProduct = {
    sync: 'sync'
};
export var enumOrderAvitoSellerAccount = {
    name: 'name',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    status: 'status'
};
export var enumCategoriesAvitoSellerAccount = {
    all: 'all',
    active: 'active',
    inactive: 'inactive',
    drafts: 'drafts'
};
export var enumActionsAvitoSellerAccount = {
    activate: 'activate',
    deactivate: 'deactivate',
    delete: 'delete'
};
export var enumSchemeAvitoPosting = {
    pvz: 'pvz',
    dbs: 'dbs',
    rdbs: 'rdbs',
    unknown: 'unknown'
};
export var enumOrderAvitoPosting = {
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    syncedAt: 'syncedAt',
    orderCreatedAt: 'orderCreatedAt',
    orderUpdatedAt: 'orderUpdatedAt'
};
export var enumCategoriesAvitoPosting = {
    all: 'all',
    awaiting: 'awaiting',
    delivering: 'delivering',
    delivered: 'delivered',
    cancelled: 'cancelled'
};
export var enumActionsAvitoPosting = {
    sync: 'sync'
};
